import React, { useContext, useEffect, useState } from "react";
import "../Style/Project.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import { AppLanguage } from "../context/ApplicationLanguage";

const API_BASE_URL = "https://server-alwaleedstone.onrender.com";

const Project = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const appLang = useContext(AppLanguage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/project?lang=${appLang.language}`
        );
        console.log("Received from API:", res.data);
        setProjects(res.data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchData();
  }, [appLang.language]);

  return (
    <div className="home-container1">
      <section className="projects-section1">
        <div className="projects-header1">
          <h2 className="section-title1">{t("Projects") || "PROJECTS"}</h2>
        </div>

        <div className="projects-grid1">
          {projects.map((project) => (
            <Link
              key={project._id}
              to={`/project/${project._id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="project-card1">
                <img
                  src={project.project_image}
                  alt={project.project_name}
                  className="project-image1"
                />
                <p className="project-name1">{project.project_name}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Project;
